import React from "react";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { useSelector } from "react-redux";

const AgreementTable = () => {
  const {
    table_data = [],
    table_headers = [],
    table_data_types,
    data_points
  } = useSelector((state) => state.membershipLengthByAgreement.table);

  return (
    <div>
      {table_data?.length ? (
        <TableWithCustomSearch
          data={table_data}
          colHeaders={table_headers}
          columns={table_data_types}
          rawDataLink={data_points?.[0].url}
          fileName="membership-length"
          dateConversion={false}
          customFn={(header, formattedValue) => {
            if (header !== "Membership") {
              return (
                <div>
                  {formattedValue.length > 32
                    ? formattedValue.substring(0, 32) + "..."
                    : formattedValue}
                </div>
              );
            }
            return formattedValue;
          }}
        />
      ) : null}
    </div>
  );
};

export default AgreementTable;
